import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { SparkTheme, useTheme } from '@spark-web/theme';
import { FC } from 'react';

import { MarketplacePartner } from '~/types/marketplace';
import { parseChannel } from '~/utils/channels';

import { CHANNEL_REQUIREMENTS } from '../constants';

import { HeaderLogos } from './header-logos';

export const HEADER_HEIGHT_PX = 70;
export const BRIGHTE_LOGO_HEIGHT = 30;

type HeaderProps = {
  channel: string | null;
  partner?: MarketplacePartner;
  containerSize?: keyof SparkTheme['contentWidth'];
  showTitle?: boolean;
};

export const Header: FC<HeaderProps> = ({
  channel: channelStr,
  partner,
  containerSize = 'large',
  showTitle = true,
}) => {
  const theme = useTheme();

  const channel = parseChannel(channelStr);
  const channelConfig = channel ? CHANNEL_REQUIREMENTS[channel] : null;
  const channelTitle = channelConfig?.title;

  const showChannelTitle = showTitle && channelTitle;

  return (
    <Stack
      css={css({
        top: 0,
        right: 0,
        width: '100%',
        height: HEADER_HEIGHT_PX + (showChannelTitle ? 40 : 0),
        zIndex: `${theme.elevation.sticky}`,
      })}
      gap="xlarge"
      data={{ testId: 'marketplace-header' }}
    >
      <Box width="full" paddingY="large" paddingX="large" as="header" borderBottom="standard" background="surface">
        <Container size={containerSize}>
          <HeaderLogos channel={channel} partner={partner} />
        </Container>
      </Box>

      {showChannelTitle ? (
        <Box width="full">
          <Container size={containerSize}>
            <Box display="flex" flexDirection="row" gap="medium" alignItems="center" marginLeft="large">
              <Text tone="primaryActive" weight="semibold">
                {channelTitle}
              </Text>
            </Box>
          </Container>
        </Box>
      ) : null}
    </Stack>
  );
};
